<template>
    <div>
        <div class="nav">
            <page-navigation v-bind:step="currentStep"></page-navigation>
        </div>
        <div class="content_main">
            <h3 class="line_blue">季度POS上传</h3>
            <div>
                <div class="rect_panel" ref="select_frame">
                    <div class="top_header">
                        <span class="title">季度POS数据</span>
                        <div class="header_right" v-on:click="download()">
                            <img class="download_icon" src="../../assets/download.svg" alt="">
                            <span class="download">下载模版</span>
                        </div>
                    </div>
                    <div class="main_content">
                        <img class="computer" src="../../assets/open_icon.png" alt="">
                        <span class="">拖曳文件到此处或</span>
                        <label id="referenceUpload">
                          <input type="file" ref="referenceUpload" @change="referenceUpload($event)">浏览器打开
                        </label>
                        <!--<a class="blue_color" v-on:click="uploadFileMethod($event)">浏览器打开</a>-->
                    </div>
                    <div v-if="showLastTime && showLastTime.length > 0">
                      <img class="success_icon" src="../../assets/Success.svg" alt="">
                      <span>当前数据：上传于{{showLastTime}}</span>
                    </div>
                </div>
                <div class="setting_panel" style="overflow: hidden;">
                    <h3 class="title" style="float: left">补货目标天数设置</h3>
                     <div id="root" style="float: left;">
                     <div class="element-a" @mouseover="gifShow()" @mouseleave="gifHidden()" style="float: right; padding-left:10px;">
                        <img class="information"  src="../../assets/tipp_icon.png" style="float: right;">
                     </div>
                     <div class="gif-wrap" id="gif" v-show="ifShowB"
             @mouseover="gifMouseOver" @mouseleave="gifMouseLeave">
                         <img class="gif" src="../../assets/step 1.gif">
                     </div>
                  </div>
                    <ul>
                        <li class="calendar_list" v-for="item in getDayList" v-on:click="changeStatus(item)">
                            <img v-if="!!item.type" src="../../assets/check_day.png" alt="">
                            <img v-if="!item.type" src="../../assets/uncheck_day.png" alt="">
                            <span v-bind:class="{ checked_day: !!item.type,check_day:!item.type}" class="day_number">{{item.name}}</span>
                        </li>
                    </ul>
                    <div class="bottom_footer">
                        <span class="black_color" href="#" v-on:click="toDefault()">恢复默认数据</span>
                        <div class="bottom_right">
                            <input type="checkbox" name="default" id="default">
                            <label for="default" v-on:click="setDefault()">设置为默认</label>
                        </div>
                        <button class="btn btn_black_bg" v-on:click="save()">保存</button>
                    </div>
                </div>
            </div>
        </div>
        <page-footer v-bind:footerStatus="status" v-bind:next="nextUrl"></page-footer>
        <tip v-if="ifShow  && sendMessage.length > 0" v-bind:status="sendStatus" v-bind:message="sendMessage"></tip>
    </div>
</template>

<script>
import PageNavigation from "@/components/common/PageNavigation";
import PageFooter from "@/components/common/PageFooter";
import Tip from "@/components/common/tip";
import { mapState, mapActions } from "vuex";
import {
  getDays,
  recoverDefaultDays,
  uploadFile,
  Download,
  setDefaultDays,
  saveDays,
  getLastTime
} from "../../util/api.js";

export default {
  name: "SettingDays",
  components: { PageNavigation, PageFooter, Tip },
  data() {
    return {
      ifShowB: false,
      BFocused: false,
      status: {
        type: "config",
        status: "start"
      },
      nextUrl: "SettingParameter",
      currentStep: 1,
      ifCheck: false,
      sendStatus: false,
      sendMessage: "",
      showLastTime: "",
      selectDays: 0
    };
  },
  computed: mapState({
    getDayList: state => state.getDayList,
    ifShow: state => state.ifShowMessage
  }),
  methods: {
    getCookie: function(name) {
      var arr;
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    gifShow() {
      this.ifShowB = true;
    },
    gifHidden() {
      if (!this.BFocused) {
        this.ifShowB = false;
      } else this.ifShowB = true;
    },
    gifMouseOver() {
      this.ifShowB = true;
      this.BFocused = true;
    },
    gifMouseLeave() {
      this.BFocused = false;
      this.ifShowB = false;
    },
    changeStatus: function(data) {
      if (this.selectDays == 1 && data.type) {
        this.$store.commit("getIfShowMessage", true);
        this.sendStatus = false;
        this.sendMessage = "参数补货目标天数至少保留一个值";
        return;
      }
      if (data.type) {
        this.selectDays--;
      } else {
        this.selectDays++;
      }
      data.type = !data.type;
    },
    toDefault: function() {
      let that = this;
      recoverDefaultDays({ userId: this.getCookie("rstuserId") })
        .then(function(res) {
          if (res.data.success == true) {
            that.selectDays = 0;
            let result = res.data.result;
            that.formatDays(result);
            that.getDayList.forEach(element => {
              if (element.type == true) {
                that.selectDays++;
              }
            });
          } else {
            that.$store.commit("getIfShowMessage", true);
            that.sendStatus = false;
            that.sendMessage = "恢复默认数据失败";
          }
        })
        .catch(function() {});
    },
    formatDays: function(result) {
      let list = [];
      let formatResult = result.split(",");
      for (var i = 5; i < 29; i++) {
        if (formatResult.indexOf(i.toString()) != -1) {
          list.push({ name: i, type: true });
        } else {
          list.push({ name: i, type: false });
        }
      }
      this.$store.commit("setDayList", list);
    },
    setDefault: function() {
      this.ifCheck = !this.ifCheck;
    },
    save: function() {
      let that = this;
      console.log(this.getDayList);
      let sentData = {
        userId: this.getCookie("rstuserId"),
        setDefault: this.ifCheck + "",
        targetDays: []
      };
      this.getDayList.forEach(element => {
        if (element.type == true) {
          sentData.targetDays.push(JSON.parse(element.name));
        }
      });
      saveDays(sentData)
        .then(function(res) {
          that.$store.commit("getIfShowMessage", true);
          if (res.data.success == true) {
            console.log(res.data);
            that.sendStatus = true;
            that.sendMessage = that.ifCheck ? "保存且修改默认成功" : "保存成功";
          } else {
            that.sendStatus = false;
            that.sendMessage = "保存失败";
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    download: function() {
      Download()
        .then(function(res) {
          let fileName = "pos模板";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(res.data, fileName + ".xlsx");
          } else {
            var a = document.createElement("a");
            a.download = fileName + ".xlsx";
            a.href = window.URL.createObjectURL(res.data);
            document.body.appendChild(a); // 修复firefox中无法触发click
            a.click();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    referenceUpload: function(e) {
      let that = this;
      const data = this.$refs.referenceUpload.files; // 获取文件对象
      if (data.length < 1) {
        return; // 检测是否有文件拖拽到页面
      }
      const formData = new FormData();
      formData.append("file", data[0], data[0].name);
      formData.append("userId", this.getCookie("rstuserId"));
      uploadFile(formData)
        .then(function(res) {
          e.target.value = "";
          that.$store.commit("getIfShowMessage", true);
          if (res.data.success == true) {
            that.sendStatus = true;
            that.sendMessage = "上传成功";
            getLastTime({ userId: that.getCookie("rstuserId") })
              .then(function(res) {
                if (res.data.success) {
                  that.showLastTime = res.data.message;
                  console.log(that.showLastTime);
                }
              })
              .catch(function() {});
          } else {
            that.sendStatus = false;
            let message = "";
            if (res.data.result == null || !res.data.result) {
              message = "";
            } else {
              message = res.data.result;
            }
            that.sendMessage = res.data.message
              ? res.data.message + message
              : "上传失败";
          }
        })
        .catch(function(error) {
          e.target.value = "";
          console.log(error);
        });
    }
  },

  mounted: function() {
    let that = this;
    that.$store.commit("getIfShowMessage", false);
    this.$store.commit("setDayList", []);
    this.$refs.select_frame.ondragleave = e => {
      e.preventDefault(); //阻止离开时的浏览器默认行为
    };
    this.$refs.select_frame.ondrop = e => {
      e.preventDefault(); //阻止拖放后的浏览器默认行为
      const data = e.dataTransfer.files; // 获取文件对象
      if (data.length < 1) {
        return; // 检测是否有文件拖拽到页面
      }
      console.log(e.dataTransfer.files);
      const formData = new FormData();
      formData.append(
        "file",
        e.dataTransfer.files[0],
        e.dataTransfer.files[0].name
      );
      formData.append("userId", this.getCookie("rstuserId"));
      uploadFile(formData)
        .then(function(res) {
          that.$store.commit("getIfShowMessage", true);
          if (res.data.success == true) {
            that.sendStatus = true;
            that.sendMessage = "上传成功";
            getLastTime({ userId: that.getCookie("rstuserId") })
              .then(function(res) {
                if (res.data.success) {
                  that.showLastTime = res.data.message;
                  console.log(that.showLastTime);
                }
              })
              .catch(function() {});
          } else {
            that.sendStatus = false;
            let message = "";
            if (res.data.result == null || !res.data.result) {
              message = "";
            } else {
              message = res.data.result;
            }
            that.sendMessage = res.data.message
              ? res.data.message + message
              : "上传失败";
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    };
    this.$refs.select_frame.ondragenter = e => {
      e.preventDefault(); //阻止拖入时的浏览器默认行为
      this.$refs.select_frame.border = "2px dashed red";
    };
    this.$refs.select_frame.ondragover = e => {
      e.preventDefault(); //阻止拖来拖去的浏览器默认行为
    };

    this.$nextTick(function() {
      let that = this;
      let userId = that.getCookie("rstuserId");
      getDays({ userId: userId })
        .then(function(res) {
          if (res.data.success == true) {
            let result = res.data.result;
            that.formatDays(result);
            that.getDayList.forEach(element => {
              if (element.type == true) {
                that.selectDays++;
              }
            });
          } else {
            that.$store.commit("getIfShowMessage", true);
            that.sendStatus = false;
            that.sendMessage = "获取目标天数失败";
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      getLastTime({ userId: userId })
        .then(function(res) {
          if (res.data.success) {
            that.showLastTime = res.data.message;
            console.log(that.showLastTime);
          }
        })
        .catch(function() {});
    });
  }
};
</script>
<style scoped>
.nav {
  padding: 0.1rem 0 0.1rem 0;
}
@media screen and (max-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 5.99rem;
      margin: 0 auto;
      margin-bottom: 0.77rem;
      padding-top: 0.19rem;
      box-shadow: 0 0 5px -3px #000;
      position: relative;
    }
}
@media screen and (min-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 5.99rem;
      padding-top: 0.19rem;
      margin-top: 0.2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      box-shadow: 0 0 5px -3px #000;
    }
}
.content_main h3 {
  text-align: left;
}
.line_blue:before {
  display: inline-block;
  width: 0.04rem;
  height: 0.24rem;
  vertical-align: middle;
  content: "";
  margin-right: 0.24rem;
  background-color: #fa5400;
}
.rect_panel {
  width: 5.08rem;
  border: 1px dashed #cecece;
  border-radius: 2px;
  padding: 0.15rem 0.19rem 0.11rem 0.15rem;
  margin: 0 auto;
}
.top_header {
  display: flex;
}
.top_header .header_right {
  flex: 1;
  text-align: right;
  cursor: pointer;
}
.download_icon {
  vertical-align: middle;
  width: 0.2rem;
}
.rect_panel .main_content {
  font-size: 0.15rem;
}
.rect_panel .main_content img {
  display: block;
  margin: 0 auto;
  margin-bottom: 0.15rem;
}
.main_content label {
  text-decoration: underline;
  color: #104eda;
  cursor: pointer;
}
.computer {
  width: 1.43rem;
}
.blue_color {
  color: #104eda;
}
.setting_panel {
  padding-top: 0.25rem;
  padding-left: 0.33rem;
  text-align: left;
}
.setting_panel ul {
  float: left;
  padding-top: 0.37rem;
  padding-left: 0.69rem;
  padding-right: 1.05rem;
  overflow: hidden;
}
li {
  list-style: none;
}
.day_number {
  position: relative;
  left: 0.45rem;
  top: -0.15rem;
}
.checked_day {
  color: #000;
  font-weight: bold;
}
.check_day {
  color: #d8d8d8;
}
.calendar_list {
  float: left;
  width: 0.66rem;
  height: 0.63rem;
  cursor: pointer;
}
.bottom_footer {
  padding: 0.52rem 1.2rem 0.37rem 0.68rem;
  display: flex;
  align-items: center;
}
.black_color {
  color: #000;
  text-decoration: underline;
  cursor: pointer;
}
.bottom_right {
  flex: 1;
  text-align: right;
}
.btn {
  width: 1.17rem;
  height: 0.46rem;
  font-size: 0.15rem;
  border: 0;
  border-radius: 2px;
  cursor: pointer;
}
.btn_black_bg {
  color: #fff;
  background-color: #000;
}
.element-a:hover {
  cursor: pointer;
  opacity: 1;
}
.gif{
  width: 800px;
  height: 500px;
}
.gif-wrap {
  font-size: 1rem;
  position: absolute;
  border-radius: 10px;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  -o-transition: all 1s ease-in-out;
  -ms-transition: all 1s ease-in-out;
  transition: all 1s ease-in-out;
}
.gif-wrap:hover {
  cursor: pointer;
  opacity: 1;
}

input {
  display: none;
}
input + label {
  display: flex;
  flex-direction: row;
}
input + label:hover {
  color: #3956ca;
}
input + label::before {
  content: "";
  background: url(../../assets/check.png) no-repeat;
  width: 0.21rem;
  height: 0.21rem;
  display: block;
  padding-right: 0.07rem;
  background-size: 0.19rem 0.19rem;
}
input:checked + label::before {
  background: url(../../assets/checked.png) no-repeat;
  background-size: 0.19rem 0.19rem;
}
.bottom_right label {
  float: right;
  padding-right: 0.15rem;
  cursor: pointer;
  line-height: 0.21rem;
  height: 0.21rem;
}
.success_icon {
  width: 0.2rem;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/page/SettingDays.vue